function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-cta-hero\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29,15.55H11.05a1.13,1.13,0,0,1,0-2.25H29a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.11,27.1H16.89a3.61,3.61,0,0,1,0-7.22h6.22a3.61,3.61,0,0,1,0,7.22Zm-6.22-5a1.36,1.36,0,1,0,0,2.72h6.22a1.36,1.36,0,0,0,0-2.72Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.44,35.68H6.56a5.43,5.43,0,0,1-5.42-5.42V9.75A5.43,5.43,0,0,1,6.56,4.32H33.44a5.43,5.43,0,0,1,5.42,5.43V30.26A5.43,5.43,0,0,1,33.44,35.68ZM6.56,6.57A3.18,3.18,0,0,0,3.39,9.75V30.26a3.18,3.18,0,0,0,3.17,3.17H33.44a3.18,3.18,0,0,0,3.17-3.17V9.75a3.18,3.18,0,0,0-3.17-3.18Z",
  fill: "#231f20"
});

function SvgCmsCtaHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgCmsCtaHero;